import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const dataHooks = createDataHooks<{
  title: {}
  text: {}
  backLink: {}
}>('sg-landing-mobile')
